<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="page__inner">
          <h1 class="title title_red page__title">Созидание</h1>
          <p class="lead page__lead" style="margin-bottom: auto">Мы предлагаем нелинейные подходы, даже если задача кажется стандартной</p>
        </div>
      </div>
    </div>

    <missionSvg />

    <page-footer
      :prev="{ name: 'heritage' }"
      :next="{ name: 'partnership' }"
    />
  </div>
</template>

<script>
import { TimelineMax, TweenMax } from 'gsap'
import missionSvg from '@/components/missionSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '../mixins/route'

export default {
  name: 'creation',
  mixins: [RouteMixin],
  components: {
    missionSvg,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      // .add(TweenMax.from('.creation-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))

    // TweenMax.from('.creation-bg', 8.5, { y: '20%', x: '-10%' })
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.creation-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
